(function () {


  function accordionInit() {


    const buttons = document.querySelectorAll(
      '.multicolumn-accordion__button'
    );


    buttons.forEach(function(button){


      if(button.classList.contains('accordion-loaded')){
        return;
      }


      button.classList.add('accordion-loaded');



      button.addEventListener('click', function(){


        const wrapper = this.closest(
          '.multicolumn-accordion'
        );


        if(!wrapper){
          return;
        }


        const content = wrapper.querySelector(
          '.multicolumn-accordion__content'
        );


        const icon = wrapper.querySelector(
          '.accordion-plus'
        );


        if(!content){
          return;
        }



        content.classList.toggle('is-open');



        if(content.classList.contains('is-open')){


          this.setAttribute(
            'aria-expanded',
            'true'
          );


          if(icon){
            icon.innerHTML = '⌃';
          }


        } else {


          this.setAttribute(
            'aria-expanded',
            'false'
          );


          if(icon){
            icon.innerHTML = '⌄';
          }


        }


      });


    });


  }



  // Initial load
  accordionInit();



  // Shopify editor reload
  document.addEventListener(
    'shopify:section:load',
    function(){
      accordionInit();
    }
  );



})();